import * as types from '../../mutation_type'
export default {
  /**
   *  判断是否存在cookie(logoimgurl,allreqdomain)
   * @param state
   * @param res
   */
  [types.EXPTYPES](state, res) {
    state.exptypes = res;
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/common/mutations/mutation.js